import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-arrow-down-inactive",
  "use": "various-arrow-down-inactive-usage",
  "viewBox": "0 0 14 27",
  "content": "<symbol viewBox=\"0 0 14 27\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-arrow-down-inactive\"><path d=\"M6 12.005V0h2v12.005h6l-7 14-7-14h6z\" fill=\"#D8D8D8\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol